import { useMemo } from 'react';

import { featureFlagsState } from '../features/auth/api/featureFlagSlice';
import { useAppSelector } from '../store';

const useMfaEnabledFlag = () => {
  const { featureFlags } = useAppSelector(featureFlagsState);

  const isMfaEnabled = useMemo(() => {
    const featureFlag = featureFlags.find((flag) => flag.feature_name === 'MFAIntegration');
    return (
      featureFlags.length &&
      (!featureFlag?.is_active || (featureFlag?.is_active && featureFlag?.is_enabled))
    );
  }, [featureFlags]);

  return isMfaEnabled;
};

export default useMfaEnabledFlag;
